export default {

    name: "PageHeader",

    props: [],

    mounted() {
        this.$el.style.visibility = 'hidden';
        window.requestAnimationFrame(() => {
            this.updateDimensions();
            this.$el.style.visibility = '';
        });

        this.updateOffset();
        this.handleScroll();
        this.registerEvents();
    },

    methods: {
        registerEvents() {
            window.addEventListener('resize', () => {
                this.updateDimensions();
                this.updateOffset();
            });

            window.addEventListener('scroll', () => {
                window.requestAnimationFrame(this.handleScroll);
            });

            this.$bus.$on('view-changed', () => {
                window.requestAnimationFrame(() => {
                    this.updateDimensions();
                    this.updateOffset();
                    this.handleScroll();
                });
            });
        },

        updateDimensions() {
            var computedStyle = getComputedStyle(this.$el.parentNode);
            var stickyNode = this.$el.firstElementChild;
            var width = this.$el.getBoundingClientRect().width;

            stickyNode.style.width = width ? width + 'px' : '';
            stickyNode.style.paddingTop = parseFloat(computedStyle.paddingTop) + 'px';
            stickyNode.style.paddingLeft = parseFloat(computedStyle.paddingLeft) + 'px';
            stickyNode.style.paddingRight = parseFloat(computedStyle.paddingRight) + 'px';
        },

        updateOffset() {
            setTimeout(() => {
                var computedStyle = getComputedStyle(this.$el);
                var height = this.$el.firstElementChild.getInnerHeight();
                var offset = height + parseFloat(computedStyle.marginBottom) + 'px';

                this.$el.nextElementSibling.style.marginTop = this.$el.offsetWidth > 0 ? offset : '';
            }, 0);
        },

        handleScroll() {
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
            if (scrollTop >= this.$el.firstElementChild.getInnerHeight() / 2 && this.$el.offsetWidth > 0) {
                this.$el.classList.add('is-scrolled');
                var computedStyle = getComputedStyle(this.$el.firstElementChild);
                var paddingBottom = parseFloat(computedStyle.paddingBottom);
                var translateY = Math.round(parseFloat(computedStyle.paddingTop) - paddingBottom);

                if (paddingBottom > 0) {
                    this.$el.firstElementChild.style.transform = `translate3d(0, -${translateY}px, 0)`;
                }
            } else {
                this.$el.classList.remove('is-scrolled');
                this.$el.firstElementChild.style.transform = `translate3d(0,0,0)`;
            }
        }
    }
};
